module.exports = __webpack_public_path__ + "static/media/logo-sm.4a799e5b.png";